export default __webpack_public_path__ + "9c32cd5d6be23f4e09e96aa478df047b.jpg";